"use client";
import React, { useState, useEffect } from 'react';

export default function Typewriter({ text, className }: { text: string, className?: string }) {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, 100); // Velocidade de digitação mais suave
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, text]);

  const remainingText = text.substring(currentText.length);

  return (
    <>
      <span className={className} aria-hidden="true">
        {currentText}
        {remainingText && (
          <span className="invisible" aria-hidden="true">
            {remainingText}
          </span>
        )}
        <span className="inline-block w-[3px] h-[0.9em] bg-current ml-1 align-baseline animate-blink-opacity"></span>
      </span>
      {/* Texto integral para crawlers de SEO e 100% indexável */}
      <span className="sr-only">{text}</span>
    </>
  );
}

